import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendar4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCalendar4"><Path d="M7.5 2C7.77614 2 8 2.22386 8 2.5V4H16V2.5C16 2.22386 16.2239 2 16.5 2C16.7761 2 17 2.22386 17 2.5V4H18.5C19.8807 4 21 5.11929 21 6.5V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V6.5C3 5.11929 4.11929 4 5.5 4H7V2.5C7 2.22386 7.22386 2 7.5 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendar4;
